import { currencyInfoAtom, siteCurrencyInfoAtom, type CurrencyInfo } from "@/modules/currency/currencyInfo.ts";
import type { Atom } from "jotai";
import { createContext } from "react";

/* eslint-disable react-refresh/only-export-components */

// NB: Provide an atom instead of the actual value to prevent needless re-renders and suspending at the root component level.
export const CurrencyContext = createContext<Atom<CurrencyInfo> | undefined>(undefined);

export function SelectedCurrencyProvider({ children }: { children: React.ReactNode }) {
    return <CurrencyContext.Provider value={currencyInfoAtom}>{children}</CurrencyContext.Provider>;
}

export function ForceSiteCurrencyProvider({ children }: { children: React.ReactNode }) {
    return <CurrencyContext.Provider value={siteCurrencyInfoAtom}>{children}</CurrencyContext.Provider>;
}
